import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { boolean } from "../../shared/src/codecs/types/boolean";
import { formEditable, TFormEditableCodec } from "../../shared/src/codecs/types/formEditable";
import { integer } from "../../shared/src/codecs/types/integer";
import { literal } from "../../shared/src/codecs/types/literal";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { union } from "../../shared/src/codecs/types/union";
import { array } from "../../shared/src/codecs/types/array";
import { uuid } from "../../shared/src/codecs/types/uuid";

export const PartyMovingReason = union([
    literal("unknown"),
    literal("job"),
    literal("new_family"),
    literal("future_family"),
    literal("family_outgrowing_current_place"),
    literal("get_on_ladder"),
    literal("downsize"),
    literal("family_live_down_there"),
    literal("like_the_area"),
    literal("other"),
    literal("not_moving"),
]);

export const PartySellingPropertyState = union([
    literal("unknown"),
    literal("property_to_sell_not_on_the_market"),
    literal("property_to_sell_on_the_market"),
    literal("property_to_sell_under_offer"),
    literal("property_to_sell_already_exchanged"),
    literal("no_property_to_sell"),
    literal("property_to_let"),
]);

export const PartyPurchasingSituation = union([
    literal("unknown"),
    literal("first_time_buyer"),
    literal("homeowner"),
    literal("investor"),
]);

export const Party1 = required({
    id: uuid(),
    situation_notes: string(),
    moving_reason: PartyMovingReason,
    selling_property_state: PartySellingPropertyState,
    purchasing_situation: PartyPurchasingSituation,
    search_criteria_area: string(),
    search_criteria_min_beds: union([integer(), nullCodec()]),
    search_criteria_max_price: union([integer(), nullCodec()]),
    search_criteria_preferences: string(),
    notes: string(),
});
export type TParty1Codec = typeof Party1;
export type TParty1 = TTypeOfCodec<TParty1Codec>;

export const Party1Editable: TFormEditableCodec<TParty1Codec> = formEditable(Party1);
export type TParty1EditableCodec = typeof Party1Editable;
export type TParty1Editable = TTypeOfCodec<TParty1EditableCodec>;

export const PartySituationFields = required({
    situation_notes: string(),
    moving_reason: PartyMovingReason,
    selling_property_state: PartySellingPropertyState,
    purchasing_situation: PartyPurchasingSituation,
});
export type TPartySituationFieldsCodec = typeof PartySituationFields;

export const PartySearchCriteriaFields = required({
    search_criteria_area: string(),
    search_criteria_min_beds: union([integer(), nullCodec()]),
    search_criteria_max_price: union([integer(), nullCodec()]),
    search_criteria_preferences: string(),
});
export type TPartySearchCriteriaFieldsCodec = typeof PartySearchCriteriaFields;

export const PartyNotesFields = required({
    notes: string(),
});
export type TPartyNotesFieldsCodec = typeof PartyNotesFields;

export const PartyListing1 = required({
    id: uuid(),
    address_short_string: string(),
    status: string(),
});
export type TPartyListing1Codec = typeof PartyListing1;
export type TPartyListing1 = TTypeOfCodec<TPartyListing1Codec>;

export const PartyEnquiry1 = required({
    enquiry_id: uuid(),
    listing_id: uuid(),
    address_short_string: string(),
    status: string(),
});
export type TPartyEnquiry1Codec = typeof PartyEnquiry1;
export type TPartyEnquiry1 = TTypeOfCodec<TPartyEnquiry1Codec>;

export const PartyReadOnly1 = required({
    is_seller_party: boolean(),
    is_buyer_party: boolean(),
    listings: array(PartyListing1),
    enquiries: array(PartyEnquiry1),
});
export type TPartyReadOnly1Codec = typeof PartyReadOnly1;
export type TPartyReadOnly1 = TTypeOfCodec<TPartyReadOnly1Codec>;
